module.exports = __webpack_public_path__ + "static/media/kids-singing.0980b787.jpg";